// Ensure the experiment has year_month in it to avoid future collision
// Note: The _20 is there to get types working, just `${number}` does not work
type ApiABExperimentIdFormat = `${string}_20${number}_${number}`;

type ApiABExperimentDefinition<TBucket extends string> = {
  buckets: TBucket[];
  defaultBucket: TBucket;
};

// List of AB experiments
export const apiABExperiments = {
  MOBILE_SEARCH_V2_B_2026_06: {
    buckets: ['DISABLED', 'ENABLED'] as string[],
    defaultBucket: 'DISABLED',
  },
  JOB_PASTE_PREFILL_2026_08: {
    buckets: ['DISABLED', 'ENABLED'] as string[],
    defaultBucket: 'DISABLED',
  },
  VOLOP_AI_SUMMARY_2026_07: {
    buckets: ['DISABLED', 'ENABLED'] as string[],
    defaultBucket: 'DISABLED',
  },
  GROUPS_SEARCH_2026_08: {
    buckets: ['DISABLED', 'ENABLED'] as string[],
    defaultBucket: 'DISABLED',
  },
} satisfies Record<ApiABExperimentIdFormat, ApiABExperimentDefinition<string>>;
